<template>
	<table class="table">
		<tbody>
			<RateRow
				:rate="rate"
				v-for="rate in rates"
				v-bind:key="rate.id"
			></RateRow>
		</tbody>
	</table>
</template>

<script>
	import RateRow from "./RateRow";

	export default {
		name: "RateTable",
		components: { RateRow },
		props: {
			rates: {
				type: Array,
				required: true
			}
		}
	};
</script>
